import React, { useEffect, useState, Fragment } from "react";
import { styled } from "@mui/material/styles";

import { Typography, Box } from "@mui/material";

import ButtonBlue from "../../../../shared/general/ButtonBlue";

import SuccessIcon from "../../../../assets/approved.png";
import ErrorIcon from "../../../../assets/rejected.png";
import CancelIcon from "../../../../assets/cancel.png";

const StyledWrapErrorResponse = styled("div")({
  maxHeight: 580,
  maxWidth: 800,
  margin: "auto",
  marginTop: 36,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "& .total": {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    marginBottom: 36,
    "& .success, .error": {
      display: "flex",
      alignItems: "center",
      "& .MuiTypography-h6": {
        fontWeight: 600,
        lineHeight: 1,
      },
      "& img": {
        marginRight: 8,
      },
    },
  },
  "& .MuiBox-root": {
    height: 450,
    overflow: "auto",
    borderRadius: 8,
    marginBottom: 16,

    "& .MuiTypography-root": {
      "&.name-error": {
        color: "#EC0013",
        fontWeight: 600,
      },
      "&.MuiTypography-gutterBottom": {
        marginBottom: 8,
      },
    },
  },
});

const ShowResponse = (props) => {
  const { errorResponse, handleCloseLoading } = props;
  return (
    <StyledWrapErrorResponse>
      {errorResponse ? (
        <div className="total">
          {errorResponse.rows > 0 ? (
            <div className="success">
              <img src={SuccessIcon} width="40" />
              <div>
                <Typography variant="h6">บันทึกข้อมูลสำเร็จ</Typography>
                <Typography color="text.secondary">{errorResponse.rows} รายการ</Typography>
              </div>
            </div>
          ) : (
            <div className="error">
              <img src={ErrorIcon} width="40" />
              <div>
                <Typography variant="h6">
                  เกิดข้อผิดพลาด โปรดลองอีกครั้ง
                </Typography>
                {errorResponse.message ? (
                  <Typography color="text.secondary">{errorResponse.message}</Typography>
                ) : (<Fragment></Fragment>)}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ marginBottom: 36, textAlign: "center" }}>
          <img src={CancelIcon} width="60" style={{ marginBottom: 16 }} />
          <Typography gutterBottom variant="h5" align="center">
            เกิดข้อผิดพลาด โปรดลองอีกครั้ง
          </Typography>
        </div>
      )}

      <div>
        <ButtonBlue variant="contained" onClick={handleCloseLoading}>
          ปิด
        </ButtonBlue>
      </div>
    </StyledWrapErrorResponse>
  );
};

export default ShowResponse;
